import type { AnalyticsProvider } from './types';

declare global {
  interface Window {
    umami?: {
      identify(uniqueId: string, data?: Record<string, unknown>): void;
      track(event: string, data?: Record<string, unknown>): void;
    };
  }
}

function hashId(userId: string): string {
  let h1 = 0xdeadbeef, h2 = 0x41c6ce57;
  for (let i = 0; i < userId.length; i++) {
    const ch = userId.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(16).padStart(14, '0');
}

function whenReady(fn: () => void, attempts = 20) {
  if (window.umami) {
    fn();
  } else if (attempts > 0) {
    setTimeout(() => whenReady(fn, attempts - 1), 250);
  }
}

export const umamiProvider: AnalyticsProvider = {
  async identify(userId: string, data?: Record<string, unknown>) {
    const deviceHash = hashId(userId + navigator.userAgent);
    const userHash = hashId(userId);
    whenReady(() => window.umami!.identify(deviceHash, { userId: userHash, ...data }));
  },
  reset() {
    whenReady(() => window.umami!.identify(''));
  },
  track(event: string, data?: Record<string, unknown>) {
    whenReady(() => window.umami!.track(event, data));
  },
};
